/* ═══════════════════════════════════════════════════════════
   missinghue.com — Animations & Nav Behavior
   IntersectionObserver reveals, nav scroll, counter animations
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── reveal on scroll ── */
  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mh-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  function initReveals() {
    document.querySelectorAll('.mh-reveal').forEach(function(el) {
      revealObserver.observe(el);
    });
  }

  /* ── nav: transparent → solid on scroll ── */
  function initNavScroll() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    // only apply transparent nav on pages with a hero section
    var hasHero = document.body.classList.contains('mh-has-hero');

    function updateNav() {
      if (!hasHero) {
        header.classList.remove('mh-nav-transparent');
        header.classList.add('mh-nav-scrolled');
        return;
      }

      if (window.scrollY > 80) {
        header.classList.remove('mh-nav-transparent');
        header.classList.add('mh-nav-scrolled');
      } else {
        header.classList.add('mh-nav-transparent');
        header.classList.remove('mh-nav-scrolled');
      }
    }

    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
  }

  /* ── counter animation (for values page) ── */
  window.mhAnimateCounters = function(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;

    var animated = false;
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !animated) {
          animated = true;

          // staggered reveal
          var items = container.querySelectorAll('.mh-counter-item');
          items.forEach(function(item, i) {
            setTimeout(function() {
              item.classList.add('mh-visible');
            }, i * 150);
          });

          // animate numbers
          container.querySelectorAll('.mh-counter-num').forEach(function(num) {
            var isCountdown = num.classList.contains('mh-countdown');
            var duration = 1500;
            var startTime = performance.now();

            if (isCountdown) {
              var startVal = parseInt(num.dataset.start, 10) || 100;
              function tickDown(now) {
                var elapsed = now - startTime;
                var progress = Math.min(elapsed / duration, 1);
                var ease = 1 - Math.pow(1 - progress, 3);
                num.textContent = Math.round(startVal - ease * startVal);
                if (progress < 1) requestAnimationFrame(tickDown);
              }
              requestAnimationFrame(tickDown);
            } else {
              var target = parseInt(num.dataset.target, 10);
              if (isNaN(target)) return;
              function tick(now) {
                var elapsed = now - startTime;
                var progress = Math.min(elapsed / duration, 1);
                var ease = 1 - Math.pow(1 - progress, 3);
                num.textContent = Math.round(ease * target);
                if (progress < 1) requestAnimationFrame(tick);
              }
              requestAnimationFrame(tick);
            }
          });
        }
      });
    }, { threshold: 0.3 });

    counterObserver.observe(container);
  };

  /* ── tab switching (for product page) ── */
  window.mhInitTabs = function(sectionId) {
    var section = document.getElementById(sectionId);
    if (!section) return;

    var buttons = section.querySelectorAll('.mh-tab-btn');
    var panels = section.querySelectorAll('.mh-tab-panel');

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tabId = btn.dataset.tab;

        buttons.forEach(function(b) { b.classList.remove('active'); });
        panels.forEach(function(p) { p.classList.remove('active'); });

        btn.classList.add('active');
        var panel = section.querySelector('#tab-' + tabId);
        if (panel) panel.classList.add('active');
      });
    });
  };

  /* ── mobile hamburger menu ── */
  window.mhToggleMobileMenu = function() {
    var menu = document.querySelector('.mh-mobile-menu');
    if (menu) menu.classList.toggle('open');
  };

  /* ── zoom overlay (for product gallery) ── */
  window.mhInitZoom = function() {
    var overlay = document.getElementById('mhZoomOverlay');
    if (!overlay) return;

    var zoomImg = document.getElementById('mhZoomImg');
    var counter = document.getElementById('mhZoomCounter');
    var prevBtn = overlay.querySelector('.mh-zoom-prev');
    var nextBtn = overlay.querySelector('.mh-zoom-next');
    var closeBtn = overlay.querySelector('.mh-zoom-close');
    var srcs = [];
    var thumbs = [];
    var preloaded = {};
    var currentIdx = 0;

    function collectSrcs() {
      srcs = [];
      thumbs = [];
      var activeGroup = document.querySelector('#mh-gallery .mh-prod-gallery.active');
      var scope = activeGroup || document.getElementById('mh-gallery');
      if (!scope) return;
      scope.querySelectorAll('[data-mh-zoom]').forEach(function(el) {
        srcs.push(el.dataset.mhZoom);
        var t = el.querySelector('img');
        thumbs.push(t ? (t.currentSrc || t.src) : '');
      });
    }

    /* download a full-res source into cache so a later showIdx is instant */
    function preload(src) {
      if (!src || preloaded[src]) return;
      var im = new Image();
      im.onload = function() { preloaded[src] = true; };
      im.src = src;
    }

    function showIdx(idx) {
      if (srcs.length === 0) return;
      currentIdx = (idx + srcs.length) % srcs.length;
      var hi = srcs[currentIdx];
      if (preloaded[hi]) {
        /* already downloaded → show full-res instantly */
        zoomImg.src = hi;
      } else {
        /* show the CORRECT photo immediately at the already-loaded thumbnail
           resolution, so we never flash the previously opened photo, then swap
           up to full-res the moment it finishes downloading */
        if (thumbs[currentIdx]) zoomImg.src = thumbs[currentIdx];
        var want = currentIdx;
        var full = new Image();
        full.onload = function() {
          preloaded[hi] = true;
          if (currentIdx === want && overlay.classList.contains('open')) zoomImg.src = hi;
        };
        full.src = hi;
      }
      if (counter) counter.textContent = (currentIdx + 1) + ' / ' + srcs.length;
      /* warm up neighbours so the next swipe / arrow tap is instant */
      preload(srcs[(currentIdx + 1) % srcs.length]);
      preload(srcs[(currentIdx - 1 + srcs.length) % srcs.length]);
    }

    /* nav povolena jen když je víc než jedna fotka a NEJDE o single-photo overlay
       (aging worn-wallet fotka nastaví .mh-single a má vlastní src, ne z galerie) */
    function canNav() { return srcs.length > 1 && !overlay.classList.contains('mh-single'); }

    document.querySelectorAll('[data-mh-zoom]').forEach(function(el) {
      el.addEventListener('click', function() {
        overlay.classList.remove('mh-single');
        collectSrcs();
        var src = el.dataset.mhZoom;
        currentIdx = srcs.indexOf(src);
        if (currentIdx === -1) currentIdx = 0;
        showIdx(currentIdx);
        overlay.classList.add('open');
        /* preload the rest of the set in the background → every swipe is instant */
        srcs.forEach(preload);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); if (canNav()) showIdx(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); if (canNav()) showIdx(currentIdx + 1); });
    if (closeBtn) closeBtn.addEventListener('click', function(e) { e.stopPropagation(); overlay.classList.remove('open'); });

    /* zoom toggle + drag */
    var zoomToggle = document.getElementById('mhZoomToggle');
    var isZoomed = false;
    var isDragging = false;
    var dragStart = { x: 0, y: 0 };
    var imgOffset = { x: 0, y: 0 };

    function resetZoom() {
      isZoomed = false;
      overlay.classList.remove('zoomed', 'dragging');
      zoomImg.style.transformOrigin = 'center center';
      zoomImg.style.transform = '';
      imgOffset = { x: 0, y: 0 };
      if (zoomToggle) zoomToggle.innerHTML = '&#x2315;';
    }

    function toggleZoom() {
      if (isZoomed) {
        resetZoom();
      } else {
        isZoomed = true;
        overlay.classList.add('zoomed');
        if (zoomToggle) zoomToggle.innerHTML = '&#x2212;';
      }
    }

    if (zoomToggle) zoomToggle.addEventListener('click', function(e) { e.stopPropagation(); toggleZoom(); });

    zoomImg.addEventListener('click', function(e) {
      if (!isZoomed) {
        /* calculate click point relative to actual image content (not padding from object-fit) */
        var rect = zoomImg.getBoundingClientRect();
        var imgW = zoomImg.naturalWidth;
        var imgH = zoomImg.naturalHeight;
        var containerW = rect.width;
        var containerH = rect.height;
        var imgRatio = imgW / imgH;
        var containerRatio = containerW / containerH;
        var renderedW, renderedH, offsetX, offsetY;
        if (imgRatio > containerRatio) {
          renderedW = containerW;
          renderedH = containerW / imgRatio;
          offsetX = 0;
          offsetY = (containerH - renderedH) / 2;
        } else {
          renderedH = containerH;
          renderedW = containerH * imgRatio;
          offsetX = (containerW - renderedW) / 2;
          offsetY = 0;
        }
        var clickX = e.clientX - rect.left;
        var clickY = e.clientY - rect.top;
        var x = Math.max(0, Math.min(100, ((clickX - offsetX) / renderedW) * 100));
        var y = Math.max(0, Math.min(100, ((clickY - offsetY) / renderedH) * 100));
        zoomImg.style.transformOrigin = x + '% ' + y + '%';
        isZoomed = true;
        overlay.classList.add('zoomed');
        if (zoomToggle) zoomToggle.innerHTML = '&#x2212;';
      } else {
        resetZoom();
      }
      e.stopPropagation();
    });

    /* drag when zoomed */
    zoomImg.addEventListener('mousedown', function(e) {
      if (!isZoomed) return;
      isDragging = true;
      overlay.classList.add('dragging');
      dragStart = { x: e.clientX - imgOffset.x, y: e.clientY - imgOffset.y };
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      imgOffset = { x: e.clientX - dragStart.x, y: e.clientY - dragStart.y };
      zoomImg.style.transform = 'scale(2.5) translate(' + (imgOffset.x / 2.5) + 'px, ' + (imgOffset.y / 2.5) + 'px)';
    });
    document.addEventListener('mouseup', function() {
      isDragging = false;
      overlay.classList.remove('dragging');
    });

    /* reset zoom on slide change */
    var origShowIdx = showIdx;
    showIdx = function(idx) {
      resetZoom();
      origShowIdx(idx);
    };

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) { resetZoom(); overlay.classList.remove('open'); }
    });

    function closeOverlay() {
      resetZoom();
      overlay.classList.remove('open');
    }

    if (closeBtn) { closeBtn.removeEventListener('click', closeBtn._handler); closeBtn._handler = function(e) { e.stopPropagation(); closeOverlay(); }; closeBtn.addEventListener('click', closeBtn._handler); }

    document.addEventListener('keydown', function(e) {
      if (!overlay.classList.contains('open')) return;
      if (e.key === 'ArrowRight') { if (canNav()) showIdx(currentIdx + 1); }
      else if (e.key === 'ArrowLeft') { if (canNav()) showIdx(currentIdx - 1); }
      else if (e.key === 'Escape') closeOverlay();
    });

    /* ── swipe doleva/doprava = další/předchozí foto (mobil) ──
       jen když NENÍ zoom (tam si ponech tap/pan); horizontální swipe potlačí
       emulovaný click, ať se omylem nespustí tap-to-zoom */
    var swStartX = 0, swStartY = 0, swTracking = false;
    overlay.addEventListener('touchstart', function (e) {
      if (!overlay.classList.contains('open') || isZoomed || e.touches.length !== 1) { swTracking = false; return; }
      swStartX = e.touches[0].clientX; swStartY = e.touches[0].clientY; swTracking = true;
    }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (!swTracking) return;
      swTracking = false;
      var t = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
      if (!t) return;
      var dx = t.clientX - swStartX, dy = t.clientY - swStartY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5 && canNav()) {
        if (e.cancelable) e.preventDefault(); /* zabraň tap-to-zoom po swipe */
        if (dx < 0) showIdx(currentIdx + 1); else showIdx(currentIdx - 1);
      }
    }, { passive: false });
  };

  /* ── sticky purchase bar (for product page) ── */
  window.mhInitStickyPurchase = function(triggerSelector) {
    var bar = document.querySelector('.mh-sticky-purchase');
    var trigger = document.querySelector(triggerSelector);
    if (!bar || !trigger) return;

    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('visible');
        } else {
          bar.classList.add('visible');
        }
      });
    }, { threshold: 0 });

    stickyObserver.observe(trigger);
  };

  /* ── mobile: smart hide/show header on scroll ── */
  function initMobileHeaderHide() {
    if (window.innerWidth > 749) return;
    var header = document.querySelector('.section-header');
    if (!header) return;

    var lastY = 0;
    var ticking = false;

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var y = window.pageYOffset || document.documentElement.scrollTop;
        if (y > 120 && y > lastY + 5) {
          header.classList.add('mh-nav-hide');
        } else if (y < lastY - 5) {
          header.classList.remove('mh-nav-hide');
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ── lazy video: play/pause based on viewport visibility ── */
  function initLazyVideos() {
    var videos = document.querySelectorAll('.mh-lazy-video');
    if (!videos.length) return;

    var videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (video.paused) video.play().catch(function() {});
        } else {
          if (!video.paused) video.pause();
        }
      });
    }, { threshold: 0.01, rootMargin: '300px 0px' });

    videos.forEach(function(v) {
      videoObserver.observe(v);
    });

    /* iOS (Low Power Mode / Data Saver) blokuje autoplay do prvního gesta -
       po dotyku zkusit spustit viditelná pauznutá videa */
    var rescuePlay = function() {
      videos.forEach(function(v) {
        if (!v.paused) return;
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          v.play().catch(function() {});
        }
      });
    };
    document.addEventListener('touchend', rescuePlay, { passive: true });
  }

  /* ── ensure body scroll is never locked from previous menu/quiz state ── */
  function unlockBodyScroll() {
    /* only remove mh-quiz-page if we're NOT on a quiz page */
    var isQuizPage = window.location.pathname.indexOf('/quiz') !== -1;
    if (!isQuizPage) {
      document.body.classList.remove('mh-quiz-page');
    }
    document.body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
    if (document.body.style.height) {
      document.body.style.height = '';
    }
    if (document.documentElement.style.overflow === 'hidden') {
      document.documentElement.style.overflow = '';
    }
  }

  /* ── init on DOMContentLoaded ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      unlockBodyScroll();
      initReveals();
      initNavScroll();
      initMobileHeaderHide();
      initLazyVideos();
    });
  } else {
    unlockBodyScroll();
    initReveals();
    initNavScroll();
    initMobileHeaderHide();
    initLazyVideos();
  }

  /* ── reset on pageshow (handles iOS Safari bfcache) ── */
  window.addEventListener('pageshow', unlockBodyScroll);

  /* ── re-init on Shopify section render (editor) ── */
  document.addEventListener('shopify:section:load', function() {
    initReveals();
  });
})();
